import { SpecialPaymentsConfigCreate } from './SpecialPaymentsConfigCreate'
import { SpecialPaymentsConfigList } from './SpecialPaymentsConfigList'
import { SpecialPaymentsConfigEdit } from './SpecialPaymentsConfigEdit'

export default {
  list: SpecialPaymentsConfigList,
  creat: SpecialPaymentsConfigCreate,
  edit: SpecialPaymentsConfigEdit,
}
